import { useTranslation } from 'react-i18next';
import { useParams, Link, NavLink, Outlet } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import CustomerProfile from './CustomerProfile';
import CustomerDocuments from './CustomerDocuments';
import ProfileIcon from '~/assets/icons/ProfileIcon';
import MediaIcon from '~/assets/icons/MediaIcon';
import { TagIcon } from '@heroicons/react/24/outline';

const CustomerDetail = () => {
  const [t] = useTranslation('customer');
  const { agentId, customerId } = useParams();

  return (
    <div className="m-auto w-full max-w-[1200px] px-8 pt-12">
      {/* Header Section */}
      <div className="mb-6">
        <div className="flex items-center gap-4 mb-4">
          <Link
            to={`/agent/${agentId}/customers`}
            className="btn btn-ghost btn-sm"
          >
            <ArrowLeftIcon className="h-4 w-4 mr-2" />
            {t('back_to_customers', 'Back to Customers')}
          </Link>
        </div>
        <h1 className="text-2xl font-bold mb-2">
          {t('customer_detail', 'Customer Detail')}
        </h1>
        <p className="text-base-content/70">
          {t('customer_detail_description', 'Detailed information about the customer')}
        </p>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 mb-6">
        <NavLink
          to=""
          end
          className={({ isActive }) =>
            `flex items-center py-3 px-6 mr-4 ${
              isActive
                ? 'border-b-2 border-primary text-primary font-medium'
                : 'text-gray-600 hover:text-gray-800'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <ProfileIcon isActive={isActive} />
              <span>{t('profiles', 'Profiles')}</span>
            </>
          )}
        </NavLink>
        <NavLink
          to="attributes"
          className={({ isActive }) =>
            `flex items-center py-3 px-6 mr-4 ${
              isActive
                ? 'border-b-2 border-primary text-primary font-medium'
                : 'text-gray-600 hover:text-gray-800'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <TagIcon className={`h-4 w-4 mr-2 ${isActive ? 'text-primary' : 'text-gray-600'}`} />
              <span>{t('attributes', 'Características del usuario')}</span>
            </>
          )}
        </NavLink>
        <NavLink
          to="media"
          className={({ isActive }) =>
            `flex items-center py-3 px-6 mr-4 ${
              isActive
                ? 'border-b-2 border-primary text-primary font-medium'
                : 'text-gray-600 hover:text-gray-800'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <MediaIcon isActive={isActive} />
              <span>{t('media', 'Media')}</span>
            </>
          )}
        </NavLink>
      </div>

      {/* Tab Content */}
      <div className="mb-24 w-full lg:mb-0">
        <Outlet />
      </div>
    </div>
  );
};

export default CustomerDetail;
